import request from "@src/util/request";
import { API_SYNCSCAN, API_SEND_CODE, API_ADD_INFO, API_UPDATE_INFO, API_APPLY_OLD, API_OCRBANK, API_GET_RESULT, API_DEALER_DOOR, API_update_QUal, API_SUBMITBANK, API_GET_BACK, API_VEHICLE_VL, API_APPLY_CARINS_SUB, API_APPLY_CARINS_GET, API_GET_FINDDATA, API_SUB_FINDDATA, API_APPLYSIGN, API_GETUSERINFO, API_SENDMESSAGE, API_STARTH5FACE } from "@src/config/api";
import { isEmpty } from "@src/util";
import { SOURCE } from '@src/config'
import { vehicleBrand } from '@src/config'
/**
 * 上传身份证正反面或者银行卡OCR认证接口
 * @param id 
 * @param type
 */
export function imageSyncScan(id: number, type: number) {
    return request.get(API_SYNCSCAN, { params: { id, type } }).then(rs => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}
/**
 * 发送验证码
 * @param phone
 */
export function sendAuthCode(phone: string | number) {
    return request.get(API_SEND_CODE, { params: { phone } }).then(rs => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}
/**
 * 保存身份证信息
 * @param obj
 */
export function saveByInformation(obj: any) {
    obj.source = SOURCE
    return request.post(obj.no ? API_UPDATE_INFO : API_ADD_INFO, obj).then(rs => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 通过身份证号获取以前申请的资料信息
 * @param idf 身份证号
 */
export function getApplyInfoByIdf(no?:string) {
    return request.get(`${API_APPLY_OLD}?no=${no||''}`).then(rs => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 获取资格查询结果
 * @param params
 */
export function getResult() {
    const form = new FormData()
    form.append('source', SOURCE)
    return request.post(API_GET_RESULT, form).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 获取春风经销商门店列表
 */
export function getCFDealerDoor(city?: string) {
    const params: any = {};
    if (city) {
        params['cityCode'] = city;
    }
    params['source'] = SOURCE;
    return request.get(API_DEALER_DOOR, { params }).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 资格预审提交
 */
export function updateQualification(params?: any) {
    params['source'] = SOURCE;
    return request.post(API_update_QUal, params).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 识别银行卡 
 */
export function recognition(accountNo: string) {
    return request.get(API_OCRBANK, { params: { accountNo } }).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 保存银行卡信息
 */
export function submitBank(params: any) {
    params['source'] = SOURCE;
    return request.post(API_SUBMITBANK, params).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 获取银行卡信息
 */
export function getfindBank(loanid?: string) {
    return request.get(API_GET_BACK + `?loanid=${loanid ? encodeURIComponent(loanid) : ''}`).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 获取春风车型列表
 */
export function getVehicleList() {
    const params: any = { vehicleBrand, status: 1 };
    return request.get(API_VEHICLE_VL, { params }).then((rs) => rs.data).then(data => {
        if (data.code == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 保存车辆和分期信息
 */
export function carInsSubmit(form: any) {
    return request.post(API_APPLY_CARINS_SUB, form).then((rs) => rs.data).then(data => {
        if (data.code == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 获取保存车辆和分期信息
 */
export function getCarIns(loanid: string) {
    return request.get(API_APPLY_CARINS_GET + '?loanid=' + encodeURIComponent(loanid)).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 根据loanId查询上传资料
 */
export function getFinDdata(loanid: string) {
    return request.get(API_GET_FINDDATA + '?loanid=' + encodeURIComponent(loanid)).then((rs) => rs.data).then(data => {
        if (data.errcode == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}

/**
 * 保存上传资料
 */
export function findSubmit(form: any) {
    return request.post(API_SUB_FINDDATA, form).then((rs) => rs.data).then(data => {
        if (data.code == 0 && !isEmpty(data.data)) {
            return data.data
        }
    })
}
/**
 * 君子签-发起人脸识别
 */
 export function startH5Face(params: any) {
    return request.get(API_STARTH5FACE, { params }).then((rs) => rs.data)
}

/**
 * 君子签-发起签约
 */
 export function applySign(params: any) {
    return request.get(API_APPLYSIGN, { params }).then((rs) => rs.data)
}
/**
 * 君子签-获取短信
 */
 export function sendMessage(params: any) {
    params['source'] = SOURCE;
    return request.get(API_SENDMESSAGE, { params }).then((rs) => rs.data)
}
/**
 * 君子签-获取用户信息
 */
 export function getUserInfo(params: any) {
    params['source'] = SOURCE;
    return request.get(API_GETUSERINFO, { params }).then((rs) => rs.data)
}
